import { ChangeDetectionStrategy, Component, effect, model, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { simpleDeepClone } from '@phx-erp/shared';
import { TabsModule } from 'primeng/tabs';
import { Product, Unit, VendorPriceListAddressLink } from '../../../../generated/generated-types';
import { VendorPriceListAddressLinkService } from '../../services/vendor-price-list-address-link.service';
import { UnitConversionConfigLinkListWidgetComponent } from '../unit-conversion-config-link-list-widget/unit-conversion-config-link-list-widget.component';
import { VendorPriceListLinkDetailWidgetComponent } from '../vendor-price-list-link-detail-widget/vendor-price-list-link-detail-widget.component';
import { ProductVendorTransportRoutesWidgetComponent } from '../../../masterdata/transport-route/components/product-vendor-transport-routes-widget/product-vendor-transport-routes-widget.component';

@Component({
  selector: 'app-vendor-product-edit-widget',
  imports: [
    VendorPriceListLinkDetailWidgetComponent,
    UnitConversionConfigLinkListWidgetComponent,
    ProductVendorTransportRoutesWidgetComponent,
    TabsModule,
    TranslatePipe
  ],
  templateUrl: './vendor-product-edit-widget.component.html',
  styleUrl: './vendor-product-edit-widget.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VendorProductEditWidgetComponent {

  partialDataModel = model<Partial<VendorPriceListAddressLink>>();
  dataModel = model<VendorPriceListAddressLink>();
  product = model<Product>();
  unit = model<Unit>();

  vendorDetailsSaved = output<VendorPriceListAddressLink>();
  activeSubTab = signal<string | number>('0');

  constructor(
    private vendorPriceListAddressLinkService: VendorPriceListAddressLinkService
  ) {
    effect(() => {
      if (this.partialDataModel()) {
        this.vendorPriceListAddressLinkService.getItemData(this.partialDataModel().id).then(data => {
          let loadedData = simpleDeepClone(data);
          this.dataModel.set(loadedData);
        });
      }
    });
  }

  onDetailsSaved(saved: VendorPriceListAddressLink): void {
    this.vendorDetailsSaved.emit(saved);
  }
}
